import { render } from "./EventPage.vue?vue&type=template&id=f84da18c&scoped=true"
import script from "./EventPage.vue?vue&type=script&scoped=true&lang=js"
export * from "./EventPage.vue?vue&type=script&scoped=true&lang=js"

import "./EventPage.vue?vue&type=style&index=0&id=f84da18c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84da18c"]])

export default __exports__